import React, { createContext, useState, useContext} from 'react';

export const PushNotificationsContext = createContext();

export const PushNotificationsProvider = ({ children }) => {
    
    const [contentPushNotification, setContentPushNotification] = useState({title: null, message: null});

    const value = {

        contentPushNotification, 
        setContentPushNotification,
    }

    return (
        <PushNotificationsContext.Provider value={value}>
            {children}
        </PushNotificationsContext.Provider>              
    )
}

export const usePushNotifications = () => {

    const context = useContext(PushNotificationsContext);
    if (context === undefined) {
        throw new Error('usePush must be used within a PushNotificationsProvider');
    }
    return context;
}